<template>
  <div class="all-wrapper">
    <HeaderComponent
      :companyname="companyname"
      :message="message"
      :icon="icon"
      :notification-count="notification_count"
     />

    <div class="drawer">
      <input class="drawer-toggle" id="drawer-checkbox" type="checkbox" v-model="isOpen">
      <label class="drawer-btn" for="drawer-checkbox"><span></span><span></span><span></span></label>
    </div>

    <div class="side-area">
      <SidemenuComponent
        :departmentId="department_id"
        :currentUserId="current_user_id"
        :message_room_id="message_room_id"
        :is_paid_member="is_paid_member"
      />
    </div>

    <div class="main-scroll-container" style="height:100vh;">
      <!-- main-area-->
      <router-view :currentUserId="current_user_id" :isNoFade="is_no_fade" />
    </div>

  </div>
</template>

<script>
import HeaderComponent from '../../common/layouts/header';
import SidemenuComponent from './Sidemenu.vue';
// 端末判別コンポーネント
import DeviceCheck from '../../common/mixins/device_check.js';

export default {
  components: {
    HeaderComponent,
    SidemenuComponent
  },
  mixins: [DeviceCheck],

  metaInfo() {
    return {
      bodyAttrs: {
        class: this.isOpen ? ['drawer-open'] : []
      }
    }
  },
  data() {
    return {
      department_id: null,
      current_user_id: null,
      companyname: null,
      is_paid_member: null,
      message: null,
      icon: null,
      account_type: '',
      message_room_id: null,
      notification_count: null,
      is_no_fade: false,
      isOpen: false,
    }
  },
  mounted () {
    this.getCompanyInfo();
    this.browserIECheck();
  },
  methods: {
    getCompanyInfo () {
      this.$auth.api.get('user_sessions')
      .then(res => {
        this.department_id = res.data.department_id;
        this.current_user_id = res.data.current_user_id;
        this.companyname = res.data.companyname;
        this.is_paid_member = res.data.is_paid_member;
        this.message = res.data.message;
        this.icon = res.data.icon;
        this.message_room_id = res.data.message_room_id;
        this.notification_count = res.data.notification_count;
      }).catch(err => {
        this.$errorHandlers.initial(err);
        if(err.response.status === 401) {
          this.$router.push({ name: 'EpLogin', query: {error_status: 401}});
        }
      })
    },
    browserIECheck(){
      var ua = navigator.userAgent;
      if(ua.indexOf('Trident') !== -1) {
        this.is_no_fade = true;
      }
    },
  },
  watch: {
    '$route' (to, from) {
      if(from.name === "EpEpCompanyEditConfirm" && to.name === "EpEpCompanyShow") {
        this.getCompanyInfo();
      }
      // 前画面情報を取得
      this.$store.commit('back_to_index_modal/setFromPage', {
        full_path: from.fullPath,
        name: from.name,
        path: from.path
      });
      this.isOpen = false;
    }
  }
}
</script>
